import { ResursTreeApi } from '../../../services/modules/tree';
import { TProprtiesResponse } from '../../resurs-props/field/types';
import { getNeighboorTree } from './getNeighboorTree';

export const getContextMenuProps = (
  nodeProps: TProprtiesResponse,
  lastSelect: {
    tree: string | null;
    objectIds: string[];
    nodes: any[];
  },
  dialogAction: (modalData: any) => void,
  location: string
) => {
  if (typeof nodeProps !== 'boolean' && nodeProps && nodeProps.commands) {
    return nodeProps.commands.map((item) => {
      if (item.key === 'key_separator') {
        return {
          separator: true,
        };
      }

      if (item.parameterList) {
        return {
          label: item.label,
          disabled: item.disabled,
          command: () => dialogAction(item),
        };
      }

      return {
        label: item.label,
        disabled: item.disabled,
        command: () => {
          ResursTreeApi.execObjectCommand({
            tree: lastSelect.tree!,
            treeNeighbor: getNeighboorTree(
              lastSelect.tree as ResursTreeApi.treeName,
              location
            ),
            objectId: nodeProps.objectId,
            command: item.key,
          });
        },
      };
    });
  }
};
